import { Button, ButtonProps } from '@mui/material';
import type { ElementType } from 'react';

export type MHMButtonProps<T extends ElementType = 'button'> = ButtonProps<T>;

export function MHMButton<T extends ElementType>(props: MHMButtonProps<T>) {
  const { children, ...rest } = props;
  return <Button {...rest}>{children}</Button>;
}
